import {
  NEWEMPLOYEE,
  SingleRow,
  BRANCHDATA,
  LOGINDATA,
  pendingCasesData,
  profileDetails,
  SalesData,
  SelfInspecData,
  UserIdManagement,
  RenewalNotification,
  RENEWALS,
  Other_Payouts,
  TOGGLE_FORM,
  Employee_Logout,
  EMPLOYEE_LOGIN_REPORTS,
  TOGGLE_PANNEL,
  UPDATE_LOGIN_REPORTS,
  EMPLOYEE_PENDING_REPORT,
  EMPLOYEE_ISSUE_REPORT,
  EMPLOYEE_REJECTED_REPORT,
  EMPLOYEE_RECONCILIATION_REPORT,
  COMPANY_REVENUE,
  COMPANY_PRODUCT_TYPE,
  POSP_REVENUE,
  EMPLOYEE_REVENUE,
  BRANCHES_LIST,
  POLICY_REPORTS,
  EMPLOYEE_LOOKUP_REPORTS
} from "./actionType";

export const fetchSalesData = (data) => {
  return { type: SalesData, payload: data };
};

export const fetchSelfInspecData = (data) => {
  return { type: SelfInspecData, payload: data };
};

export const fetchProfileData = (data) => {
  return { type: profileDetails, payload: data };
};

export const fetchPendingCases = (data) => {
  return { type: pendingCasesData, payload: data };
};

export const fetchUsers = (data) => {
  return { type: UserIdManagement, payload: data };
};

export const handleLoginData = (payload) => ({ type: LOGINDATA, payload });

export const handleBranchData = (payload) => {
  return { type: BRANCHDATA, payload };
};

export const handleSingleRow = (payload) => {
  return { type: SingleRow, payload };
};

export const handleNewEmployee = (payload) => {
  return { type: NEWEMPLOYEE, payload };
};

export const handleRenewalNotification = (payload) => {
  return { type: RenewalNotification, payload };
};

export const handleRenewals = (payload) => {
  return { type: RENEWALS, payload };
};

export const handleOtherPayouts = (payload) => {
  return { type: Other_Payouts, payload };
};

export const toggleOfflineForms = (payload) => {
  return { type: TOGGLE_FORM, payload };
};
export const togglePannel = (payload) => {
  return { type: TOGGLE_PANNEL, payload };
};

export const handleEmployeeLogout = (payload) => {
  return { type: Employee_Logout, payload };
};

export const empLoginReports = (payload) => {
  return { type: EMPLOYEE_LOGIN_REPORTS, payload };
};
export const empPendingReports = (payload) => {
  return { type: EMPLOYEE_PENDING_REPORT, payload };
};
export const empRejectReports = (payload) => {
  return { type: EMPLOYEE_REJECTED_REPORT, payload };
};
export const empIssueReports = (payload) => {
  return { type: EMPLOYEE_ISSUE_REPORT, payload };
};
export const empReconReports = (payload) => {
  return { type: EMPLOYEE_RECONCILIATION_REPORT, payload };
};

export const empLookupReports = (payload)=>{
  return {type: EMPLOYEE_LOOKUP_REPORTS,payload}
}

export const updateLoginReports = (payload) => {
  return { type: UPDATE_LOGIN_REPORTS, payload };
};

export const companyRevenue = (payload) => {
  return { type: COMPANY_REVENUE, payload };
};

export const compantProductType = (payload) => {
  return { type: COMPANY_PRODUCT_TYPE, payload };
};

export const pospRevenue = (payload) => {
  return { type: POSP_REVENUE, payload };
};

export const employeeRevenue = (payload) => {
  return { type: EMPLOYEE_REVENUE, payload };
};

export const branchesList = (payload) => {
  return { type: BRANCHES_LIST, payload };
};

export const policyReports = (payload)=>{
  return {type:POLICY_REPORTS,payload}
}
